<template>
    <keep-alive>
         <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal_size md_size">
                    <a href="JavaScript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                    <dl class="modal_content">
                        <dt class="ellipsis">
                            <i>Search User</i>
                        </dt>
                        <dd>
                            <div class="srchModal_wrap select_set2">
                                <dl class="dl_search">
                                    <dd data-input-type="select">
                                        <select class="slt_white w100p" v-model="selectedSearchOption">
                                            <option value="ID">User ID</option>
                                            <option value="NAME">User Name</option>
                                            <option value="EMAIL">E-mail</option>
                                        </select>
                                    </dd>
                                    <dd data-input-type="input" class="clearable">
                                        <input type="text" placeholder="" class="text_input w100p"
                                            v-model="searchValue"
                                            v-clearable
                                            @keyup.enter.stop="search()">
                                    </dd>
                                    <dd class="btn">
                                        <a href="JavaScript:" class="btn_srch" @click="search()">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                                    </dd>
                                </dl>
                            </div>

                            <div class="grid_wrap">
                                <div class="grid_total">
                                    {{$t('TITLE.TOTAL.COUNT')}} : <em>{{ resultCount | numberFormat }}</em>
                                </div>
                                <div class="grid_wrap mt-10">
                                    <toast-grid
                                        :gridId="gridId"
                                        :columns="columns"
                                        :data="gridData"
                                        :options="options"
                                        :ref="gridId"
                                        :key="gridKey"
                                        :pageOptions="pageOptions"
                                        :isTotalCount="false"
                                        :click="onGridClick"
                                    />
                                </div>
                            </div>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    </keep-alive>
</template>
<script>
import Vue from 'vue';
import qs from 'query-string';
import axios from 'axios';
import { SDLUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';
import ToastGrid from '~c/ToastGrid';

export default {
    name: 'searchModelPopup',
    components: {
        'toast-grid': ToastGrid,
    },
    props: {
        onUserSelect: { type: Function }
    },
    data() {
        return {
            gridId: 'searchPopupGrid',
            loginName: '',
            gridKey: 0,
            resultCount: 0,

            selectedSearchOption: 'ID',

            searchValue: '',

            columns: [
                {
                    header: 'User ID',
                    name: 'LOGIN_ID',
                    width: 250,
                    sortable: false
                },
                {
                    header: 'User Name',
                    name: 'LOGIN_NAME',
                    width: 250,
                    sortable: false
                },
                {
                    header: 'E-mail',
                    name: 'EMAIL',
                    resizeable: true,
                    sortable: false
                },
            ],
            gridData: [],
            options: {
                scrollY: false,
                scrollX: false,
                minBodyHeight: 80,
                // rowHeaders: ['checkbox'],
            },
            pageOptions: {
                useClient: true,
                perPage: 10,
            },
        };
    },
    mounted() {
        // this.onSearch();
    },
    methods: {
        validateParams() {
			if (this.searchValue.trim().length < 4) {
                SDLUtil.alert({
                    msg: 'Please enter a search term length  greater than 3',
                });

                return false;
            }else{
            	if(this.selectedSearchOption == 'EMAIL'){
    				const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    				if(!(emailPattern.test(this.searchValue.trim()))){
    					 SDLUtil.alert({
    	                    msg: 'Please enter a valid email address.',
    	                });
    					return false;
    				}
    			}
            }
            
            return true;
        },
        prepSearchParams(exclude = []) {
            let params = {
                search_gubun: this.selectedSearchOption, // ID, NAME, EMAIL
                search_value: this.searchValue,
            };
            console.log('search.params ==> ', params);
            return params;
        },
        async search() {
            if (!this.validateParams()) return;

            const formData = this.prepSearchParams();

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(`${SDLUtil.API_URL}/basis/anysvcmobile/approvalManagement/SearchId.skp`, 
                    qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(res => {
                    this.resultCount = res.data.searchIdList.length;
                    console.log('pop.resp.data ==> ', res.data);
                    this.gridData = res.data.searchIdList;
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        onGridClick(event, rowData, grid) {
            if (event.rowKey === undefined) return;
            console.log('CLICKED ROW', rowData[event.rowKey]);
            const userId = rowData[event.rowKey].LOGIN_ID;
            this.onUserSelect(userId);
            this.$emit('close');
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/approvalManagement/SearchIdPopup.vue